import * as tslib_1 from "tslib";
import cx from 'classnames';
import React from 'react';
import GeneralSpinner from '../GeneralSpinner';
import Styles from "./List.css";
import ListHeader from './ListHeader';

var List = function List(_a) {
  var isLoading = _a.isLoading,
      children = _a.children,
      className = _a.className,
      otherProps = tslib_1.__rest(_a, ["isLoading", "children", "className"]);

  return React.createElement("div", {
    className: cx(Styles.list, className)
  }, React.createElement(ListHeader, tslib_1.__assign({}, otherProps, {
    isLoading: isLoading
  })), isLoading ? React.createElement(GeneralSpinner, null) : children);
};

export default List;